function onBoxWheel(e) {
  e.preventDefault();
  let el = e.currentTarget;
  let {direction, onScroll} = el.__vWheelScrollOption;
  let {pixelX, pixelY} = dsf.normalizeWheel(e);
  if (!pixelY && !pixelX) return;
  if (direction == 'x') {
    let pixel = pixelX || -pixelY;
    el.scrollLeft += pixel;
  } else if (direction == 'y') {
    el.scrollTop += pixelY;
  } else {
    el.scrollTop += pixelY;
    el.scrollLeft += pixelX;
  }
  onScroll?.();
}

export default {
  install(Vue) {
    /**
     * v-wheel-scroll="{direction: 'x', onScroll: Function}"
     * 用于在overflow：hidden下实现鼠标滚动
     * @param direction {'x'|'y'|'both'} 滚动方向
     * @param onScroll {Function} 滚动监听回调
     */
    Vue.directive("wheel-scroll", {
      inserted(el, {value, expression}){
        if (expression == 'x' || expression == 'y' || expression == 'both') {
          value = expression;
        }
        if (dsf.isString(value)) {
          value = {direction: value};
        }
        dsf.setObjAttr(el, '__vWheelScrollOption', {
          direction: value?.direction || 'both',
          onScroll: value?.onScroll
        })
        el.addEventListener("wheel", onBoxWheel);
      },
      unbind(el) {
        el.removeEventListener("wheel", onBoxWheel);
      },
    });
  }
}